import Highlight from "@tiptap/extension-highlight";
import TextAlign from "@tiptap/extension-text-align";
import { EditorContent, useEditor } from "@tiptap/react";
import StarterKit from "@tiptap/starter-kit";
import React from "react";

import MenuBar from "./menu-bar";

interface RichTextEditorProps {
  /** HTML inicial / controlado (preferido). */
  content?: string;
  /** Alias usado por alguns formulários com react-hook-form (`field.value`). */
  value?: string;
  onChange: (content: string) => void;
}

export default function RichTextEditor({
  content,
  value,
  onChange,
}: RichTextEditorProps) {
  const html = content ?? value ?? "";

  const editor = useEditor({
    extensions: [
      StarterKit.configure({
        bulletList: {
          HTMLAttributes: {
            class: "list-disc ml-3",
          },
        },
        orderedList: {
          HTMLAttributes: {
            class: "list-decimal ml-3",
          },
        },
      }),
      TextAlign.configure({
        types: ["heading", "paragraph"],
      }),
      Highlight,
    ],
    content: html,
    editorProps: {
      attributes: {
        class: "min-h-[156px] rounded-md border border-input bg-background text-foreground px-3 py-2 focus:outline-none",
      },
    },
    onUpdate: ({ editor }) => {
      onChange(editor.getHTML());
    },
  });

  React.useEffect(() => {
    if (editor && html !== editor.getHTML()) {
      editor.commands.setContent(html, { emitUpdate: false });
    }
  }, [html, editor]);

  return (
    <div>
      <MenuBar editor={editor} />
      <EditorContent editor={editor} />
    </div>
  );
}
